import { useEffect } from "react";
import { useLockBodyScroll } from "./useBodyScrollLock";

export const useDisableBodyScroll = (disableScroll: boolean) => {
  const scrollLock = useLockBodyScroll();

  useEffect(() => {
    if (disableScroll) {
      scrollLock.lockScroll();
    } else {
      scrollLock.unlockScroll();
    }

    // If you haven't unlocked unlock during cleanup
    return () => {
      scrollLock.unlockScroll();
    };
  }, [disableScroll]);
};
